import type { VideoEmbedProps } from "@op/puck-types";
import { Dc_Media_VideoEmbed } from "@op/sf-op";
import { useTheme, useTranslation } from "@op/utils";
import { useMemo, useState } from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";

const VideoEmbed = ({ videoId, title, children }: VideoEmbedProps) => {
  const [iframeLoaded, setIframeLoaded] = useState<boolean>(false);
  const { container } = useTheme();

  const { videoEmbed } = useTranslation();

  function onIframeAdded() {
    setIframeLoaded(true);
  }

  const consentText = useMemo(
    () =>
      iframeLoaded ? null : (
        <span className="w-full text-caption font-caption text-default-font">
          {videoEmbed.consent}
        </span>
      ),
    [iframeLoaded, videoEmbed.consent]
  );

  return (
    <>
      <Dc_Media_VideoEmbed
        noContainer={!container}
        text={children}
        consent={consentText}
      >
        <div className="w-full aspect-video" onClick={onIframeAdded}>
          <LiteYouTubeEmbed
            id={videoId}
            cookie={false}
            title={title}
            lazyLoad
            poster="hqdefault"
            playlist={false}
            adNetwork={false}
            alwaysLoadIframe={false}
            aspectWidth={16}
            aspectHeight={9}
            autoplay={false}
            muted={false}
            onIframeAdded={onIframeAdded}
            stopOnEnd={true}
            webp={true}
          />
        </div>
      </Dc_Media_VideoEmbed>
    </>
  );
};

export default VideoEmbed;
